export function sanitizeString(str: string): string {
  return str.replace(/\r\n/g, ' ').replace(/\n\n/g, ' ').trim()
}
